import React from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { SelectPanelContainer } from './StyledComponents';

import CloseIcon from '@mui/icons-material/Close';

const BulkActionPanelWrapper = ({ isVisible, count, countTitle, onClearSelected, children, ...rest }) => (
  <SelectPanelContainer isVisible={isVisible} {...rest}>
    {count && (
      <Box
        bgcolor="primary.main"
        color="common.white"
        px={2}
        borderRadius="8px 0 0 8px"
        display="flex"
        alignItems="center"
      >
        <Typography variant="h6">{count}</Typography>
      </Box>
    )}
    <Stack direction="row" alignItems="center" spacing={2} py={1.5} pr={1.5}>
      <Typography variant="body1" sx={{ mr: '40px !important' }}>
        {countTitle}
      </Typography>
      {isVisible && children}
      <IconButton type="button" onClick={onClearSelected}>
        <CloseIcon />
      </IconButton>
    </Stack>
  </SelectPanelContainer>
);
export default BulkActionPanelWrapper;
